import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { latestArticles } from '@/mocks/data';

const articleContents: Record<string, { content: string; relatedIds: number[] }> = {
  'dingliu-wanghong-lu-yin-xie-lou': {
    content: `<p>近日，一段疑似某知名网红私下辱骂粉丝的录音在网上疯传。该网红拥有超过1200万粉丝，常年以"邻家哥哥"的亲切阳光形象示人。然而这段录音的内容却令人大跌眼镜。</p>
    <p>录音中，该网红用极其粗俗的语言辱骂自己的粉丝群体，称粉丝是"韭菜""傻子""提款机"，并表示自己只是在"演戏给傻子看"。录音时长约3分钟，声音特征与该网红高度吻合。</p>
    <p>消息曝光后，该网红的社交媒体评论区瞬间被愤怒的粉丝攻陷。大量粉丝表示心碎，"原来我们在他眼中就是这样的存在"。该网红所属的MCN机构连夜发布致歉声明，称"正在调查录音真伪"。</p>
    <p>业内人士分析认为，如果录音被证实为真，该网红将面临至少5000万违约金以及多个品牌代言解约的风险。目前已有三个品牌宣布暂停与该网红的合作。</p>
    <p>17吃瓜将持续关注此事件的后续发展。</p>`,
    relatedIds: [2, 3, 5],
  },
  'zhubo-zhi-bo-jing-tou-yi-wai': {
    content: `<p>昨晚9点，某知名女主播在直播过程中疑似忘记开启美颜滤镜，导致真实容貌意外曝光，与平日精修照片呈现的巨大反差引发全场哗然。</p>
    <p>据当时在直播间的观众描述，该主播的容貌与平日精致妆容相比判若两人。直播间人数在短短5分钟内从平时的8万暴涨至超过30万，弹幕刷屏速度创下该主播直播以来的最高纪录。</p>
    <p>有技术人士分析，这很可能是一次美颜软件故障或主播操作失误导致的事件。该主播的团队至今未对此事作出正式回应。</p>
    <p>值得注意的是，这已经是本月内发生的第三起主播美颜翻车事件。随着直播行业竞争加剧，越来越多的主播被爆出真实容貌与直播形象严重不符的问题。</p>
    <p>法律人士指出，如果主播利用虚假形象进行商业活动获取利益，可能构成消费欺诈。17吃瓜建议广大粉丝理性看待网络形象。</p>`,
    relatedIds: [1, 4, 7],
  },
  'qianwan-bozhu-xu-jia-xuan-chuan': {
    content: `<p>据知情人士透露，某拥有千万粉丝的知名博主因涉嫌在其直播带货中虚假宣传产品功效，已被当地市场监管局正式立案调查。</p>
    <p>据了解，该博主在直播中宣称某款保健品具有"抗癌""延年益寿"等功效，并以"亲身经历"现身说法。但经检测，该产品仅为普通食品，根本不具备其所宣称的任何药用价值。</p>
    <p>市场监管局表示，已收到超过200起相关消费投诉，涉及金额初步统计超过800万元。调查组将对该博主的所有直播内容进行逐条审查。</p>
    <p>这是自《网络直播营销管理办法》实施以来，涉案金额最大的虚假宣传案件之一。多位法律专家表示，如果查证属实，该博主可能面临吊销直播资格、巨额罚款乃至刑事责任。</p>
    <p>该事件也引发了直播行业的大规模自查。多位头部主播纷纷下架了涉及"功效宣传"的商品链接。</p>`,
    relatedIds: [6, 8, 1],
  },
  'nantuan-chengyuan-shenye-yuehui': {
    content: `<p>昨晚有媒体拍到某当红男团成员深夜与一名神秘女子共同返回某高档公寓，两人举止亲密。消息曝光后短短一小时内就登上热搜榜首。</p>
    <p>据拍摄画面显示，两人从一辆黑色商务车中下来后，该男子主动为神秘女子开门并搭肩一同进入公寓。两人在公寓门口停留约5分钟后进入电梯。</p>
    <p>目前该男子所属经纪公司尚未对此作出回应。但其粉丝后援会已紧急发布声明，呼吁粉丝"不信谣不传谣，等待官方回应"。然而声明底下的评论区已经炸开锅。</p>
    <p>部分粉丝表示理解，"毕竟偶像也是人，有恋爱自由"，但也有大量粉丝心碎脱粉，该男团的官方微博在一夜间掉粉超过15万。</p>
    <p>娱乐圈资深人士分析称，偶像恋爱曝光对事业的打击程度取决于经纪公司的危机公关能力。该男团即将在下月举行亚洲巡演，此次事件是否会影响演出门票销售备受关注。</p>`,
    relatedIds: [1, 8, 5],
  },
  'daweiwang-bozhu-cui-tu-zheng-ju': {
    content: `<p>一位自称曾在大胃王博主团队工作过的前员工，通过17吃瓜平台实名举报，提供了大量该博主长期催吐的聊天记录和影像证据。</p>
    <p>根据举报人提供的聊天记录显示，该博主每次录制大胃王视频前都会提前准备催吐工具，在录制完成后立即进行催吐操作。举报人还提供了多段该博主在后台进行催吐的偷拍视频。</p>
    <p>"我一直良心不安，"举报人在举报信中写道，"每次看到他对着镜头说'真好吃''再来一碗'的时候，想到拍摄结束后他在厕所催吐的样子，我就觉得欺骗了所有观众。"</p>
    <p>这一爆料在网络上引发巨大反响。大量网友表示"被骗了这么多年"，该博主的粉丝数量在24小时内暴跌超过百万。</p>
    <p>食品安全专家指出，长期催吐不仅欺骗消费者，更对博主本人的健康造成严重危害。多个大胃王挑战赛主办方也宣布暂停与该博主的合作。</p>`,
    relatedIds: [6, 3, 9],
  },
  'meizhuang-bozhu-shou-jia-ju-bao': {
    content: `<p>近日超500名消费者联合向12315举报某知名美妆博主直播售假，涉及多个大牌化妆品。据初步统计，涉案金额可能高达千万元。</p>
    <p>举报人代表向记者展示了多份第三方检测报告，证实该博主直播中销售的多款"正品代购"化妆品均为仿冒品。其中某品牌粉底液的成分检测结果显示，与专柜正品完全不同。</p>
    <p>"我们都是她多年的老粉，完全不敢相信她会卖假货，"一位举报者表示，"这些假货用了之后我的脸过敏红肿了一周，去医院花了三千多。"</p>
    <p>市场监管局已介入调查，并要求该博主配合提供所有销售记录和进货凭证。业内人士预测，此案可能成为直播带货领域里程碑式的消费者维权案例。</p>
    <p>17吃瓜提醒广大消费者，网购化妆品一定要选择正规渠道，保留好购买凭证，遇到假货及时向监管部门举报。</p>`,
    relatedIds: [3, 2, 7],
  },
  'zhibo-jian-ba-jia-ge-chong-tu': {
    content: `<p>昨晚某平台两位头部带货主播在各自直播间隔空互怼，互相暗讽对方售卖假货，引发双方粉丝在评论区激烈互撕，场面一度失控。</p>
    <p>据在场观众描述，主播A在直播中突然含沙射影地表示"某些人的货，懂的都懂，都是从一些不正规渠道拿的"，虽然没有点名道姓，但粉丝们立刻锁定了主播B。</p>
    <p>不到半小时后，主播B在自己的直播间直接回怼："我做直播带货五年了，每一件商品都有正规进货凭证，不像某些人连品牌授权书都拿不出来。"</p>
    <p>双方的直播间在随后两小时内分别涌入超过50万吃瓜观众，弹幕刷屏速度之快创下了该平台今年的新纪录。两大主播的粉丝也在社交平台上互相攻击，相关话题迅速登上热搜。</p>
    <p>平台官方表示正在调查此事，将依法依规处理。不少业内人士认为，这种主播之间的公开互怼虽然能带来短期流量，但对整个直播带货行业的信誉度是巨大打击。</p>`,
    relatedIds: [2, 6, 3],
  },
  'yinyuejie-caizi-hunwai-qing': {
    content: `<p>今日凌晨，某知名音乐人的妻子在社交平台发布长文，控诉其在婚内多次出轨，并晒出了多张聊天记录截图作为证据。</p>
    <p>该长文详细描述了音乐人在过去两年间与至少三名不同女性的暧昧关系，并附上了微信聊天记录、转账记录以及酒店开房记录作为证据。文章言辞激烈，字里行间充满愤怒与失望。</p>
    <p>"我为这个家付出了全部，换来的却是这样的背叛，"其妻子在文中写道，"我决定不再忍耐，将这些事情公之于众，也希望大家认清这个人的真实面目。"</p>
    <p>该音乐人所属的经纪公司截至发稿时尚未发布任何声明。但其个人社交账号的评论区已经被大量愤怒的粉丝和吃瓜群众占领，评论数量在一小时内突破了10万条。</p>
    <p>多位娱乐圈知情人士透露，该音乐人目前正在筹备下月的巡回演唱会，此次出轨风波可能会对演唱会票房造成严重影响。已有部分赞助商开始评估是否继续合作。</p>`,
    relatedIds: [4, 1, 9],
  },
  'duanshipin-daren-bei-bao-chao-xi': {
    content: `<p>有网友制作了逐帧对比视频，揭示某拥有百万粉丝的短视频达人长期抄袭海外知名博主的内容，从选题到分镜几乎一模一样。</p>
    <p>对比视频中，该短视频达人近半年发布的40余条视频中，至少有28条与多位海外博主的内容高度雷同。不仅是选题和创意相似，连分镜角度、运镜方式、甚至广告植入的位置都惊人地一致。</p>
    <p>"这已经不是简单的'借鉴'或'致敬'了，完全就是逐帧复刻，"制作对比视频的原作者表示，"他甚至连别人视频里的一些错误都原样复制过来了，这明显是没有经过独立思考的直接搬运。"</p>
    <p>消息曝光后，该短视频达人的粉丝数量在24小时内暴跌超过30万。多位品牌方紧急暂停了与其的合作，其中包括两个即将上线的大型营销活动。</p>
    <p>知识产权律师指出，虽然短视频领域的创意保护在司法实践中仍存在争议，但如果抄袭事实成立，该达人可能面临品牌方的违约索赔以及原作者的侵权诉讼。17吃瓜将持续关注此事进展。</p>`,
    relatedIds: [1, 8, 6],
  },
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const fallbackArticle = latestArticles[0];
  const article = latestArticles.find((a) => a.slug === slug) || fallbackArticle;

  if (!article) {
    return (
      <>
        <Navbar />
        <main>
          <section className="container-page py-20 text-center">
            <h1 className="text-2xl font-bold text-foreground-950">文章未找到</h1>
            <Link to="/" className="btn-primary inline-flex items-center gap-2 mt-6 cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
          </section>
        </main>
        <Footer />
      </>
    );
  }

  const articleData = articleContents[article.slug] || { content: '', relatedIds: [] };
  const relatedArticles = articleData.relatedIds
    .map((id) => latestArticles.find((a) => a.id === id))
    .filter(Boolean) as typeof latestArticles;

  const categoryName = article.category;

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: article.image,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: '2026-07-07T08:00:00+08:00',
    publisher: {
      '@type': 'Organization',
      name: '17吃瓜',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://whzjzcgs.cn/' },
      { '@type': 'ListItem', position: 2, name: categoryName, item: `http://whzjzcgs.cn/category/${article.categorySlug}` },
      { '@type': 'ListItem', position: 3, name: article.title, item: `http://whzjzcgs.cn/article/${article.slug}` },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />

        <section className="relative w-full pt-16">
          <div className="bg-background-200">
            <div className="container-page py-8 md:py-12">
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="lg:w-3/5 lg:pr-8">
                  <nav className="flex items-center gap-2 text-xs text-secondary-400 mb-4 flex-wrap" aria-label="面包屑导航">
                    <Link to="/" className="hover:text-foreground-800 transition-colors cursor-pointer">首页</Link>
                    <i className="ri-arrow-right-s-line"></i>
                    <Link to={`/category/${article.categorySlug}`} className="hover:text-foreground-800 transition-colors cursor-pointer">{categoryName}</Link>
                    <i className="ri-arrow-right-s-line"></i>
                    <span className="text-primary-400 truncate max-w-[200px]">{article.title}</span>
                  </nav>
                  <span className="inline-block bg-primary-500/20 text-primary-500 text-xs px-2.5 py-1 rounded-full mb-4">
                    独家爆料
                  </span>
                  <h1 className="text-xl md:text-3xl font-bold text-foreground-950 leading-snug mb-4">
                    {article.title}
                  </h1>
                  <p className="text-secondary-500 text-sm leading-relaxed mb-6">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-secondary-500 mb-6">
                    <span><i className="ri-user-line mr-1"></i>{article.author}</span>
                    <span><i className="ri-time-line mr-1"></i>{article.time}</span>
                    <span><i className="ri-eye-line mr-1"></i>{article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views} 阅读</span>
                    <span><i className="ri-chat-1-line mr-1"></i>{article.comments >= 10000 ? `${(article.comments / 10000).toFixed(0)}万` : article.comments} 评论</span>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-6">
                    {article.tags.map((tag) => (
                      <span key={tag} className="bg-background-300 text-secondary-500 text-xs px-2.5 py-1 rounded-full">
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="lg:w-2/5 flex gap-3">
                  <div className="w-[40%] rounded-lg overflow-hidden h-[200px] md:h-[280px]">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={`${article.title} - 17吃瓜独家爆料`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="w-[60%] rounded-lg overflow-hidden h-[200px] md:h-[280px]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Dark%20investigative%20journalism%20scene%20with%20documents%20and%20evidence%20on%20a%20desk%2C%20dramatic%20red%20accent%20lighting%2C%20cinematic%20noir%20photography%2C%20mysterious%20detective%20atmosphere%2C%20dark%20shadows%2C%20professional%20composition%2C%20deep%20crimson%20and%20charcoal%20palette&width=960&height=720&seq=article-detail-secondary&orientation=landscape"
                      alt="独家证据"
                      title={`${article.title} - 吃瓜细节图`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-8 md:py-12">
          <div className="container-page max-w-3xl">
            <article
              className="prose prose-invert max-w-none text-foreground-700 text-sm md:text-base leading-relaxed space-y-4"
              dangerouslySetInnerHTML={{ __html: articleData.content || `<p>文章内容加载中...</p>` }}
            />

            <div className="mt-10 pt-8 border-t border-background-300/50">
              <div className="flex items-center gap-4">
                <span className="text-secondary-500 text-sm">分享到：</span>
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 hover:bg-primary-500/30 transition-colors cursor-pointer" aria-label="分享到微博">
                  <i className="ri-weibo-line text-foreground-600 text-sm"></i>
                </button>
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 hover:bg-primary-500/30 transition-colors cursor-pointer" aria-label="分享到微信">
                  <i className="ri-wechat-line text-foreground-600 text-sm"></i>
                </button>
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 hover:bg-primary-500/30 transition-colors cursor-pointer" aria-label="复制链接">
                  <i className="ri-link text-foreground-600 text-sm"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        {relatedArticles.length > 0 && (
          <section className="bg-background-100 py-10 md:py-14">
            <div className="container-page">
              <div className="mb-8">
                <h2 className="text-xl font-bold text-foreground-950">
                  相关文章
                </h2>
              </div>
              <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 md:mx-0 md:px-0">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.slug}`}
                    className="flex-shrink-0 w-[260px] md:w-[280px] bg-background-200 rounded-lg overflow-hidden cursor-pointer group transition-transform hover:-translate-y-1 duration-300"
                  >
                    <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden">
                      <img
                        src={ra.image}
                        alt={ra.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="bg-primary-500/90 text-foreground-50 text-xs px-2 py-0.5 rounded-full">
                          {ra.category}
                        </span>
                      </div>
                    </div>
                    <div className="p-4">
                      <p className="text-foreground-700 text-sm leading-relaxed line-clamp-2 group-hover:text-foreground-950 transition-colors">
                        {ra.title}
                      </p>
                      <p className="text-secondary-600 text-xs mt-2">{ra.time}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}